/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Sharing_Connected_DescInputs */

const es_privacy_policy_sharing_connected_desc = /** @type {(inputs: Privacy_Policy_Sharing_Connected_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facilitamos el intercambio entre Nexata y servicios externos unicamente segun sus instrucciones. Nunca modificamos ni eliminamos datos sin su accion explicita.`)
};

const en_privacy_policy_sharing_connected_desc = /** @type {(inputs: Privacy_Policy_Sharing_Connected_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We facilitate data exchange between Nexata and external services only per your instructions. We never modify or delete data without your explicit action.`)
};

/**
* | output |
* | --- |
* | "We facilitate data exchange between Nexata and external services only per your instructions. We never modify or delete data without your explicit action." |
*
* @param {Privacy_Policy_Sharing_Connected_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_sharing_connected_desc = /** @type {((inputs?: Privacy_Policy_Sharing_Connected_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Sharing_Connected_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_sharing_connected_desc(inputs)
	return en_privacy_policy_sharing_connected_desc(inputs)
});
export { privacy_policy_sharing_connected_desc as "privacy_policy.sharing.connected_desc" }